// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FieldsArrayController from "./fields_array_controller"
application.register("fields-array", FieldsArrayController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import RecurringSchedule__PairController from "./recurring_schedule/pair_controller"
application.register("recurring-schedule--pair", RecurringSchedule__PairController)

import RecurringSchedule__RootController from "./recurring_schedule/root_controller"
application.register("recurring-schedule--root", RecurringSchedule__RootController)

import RubyUi__AccordionController from "./ruby_ui/accordion_controller"
application.register("ruby-ui--accordion", RubyUi__AccordionController)

import RubyUi__AlertDialogController from "./ruby_ui/alert_dialog_controller"
application.register("ruby-ui--alert-dialog", RubyUi__AlertDialogController)

import RubyUi__CheckboxGroupController from "./ruby_ui/checkbox_group_controller"
application.register("ruby-ui--checkbox-group", RubyUi__CheckboxGroupController)

import RubyUi__ComboboxContentController from "./ruby_ui/combobox_content_controller"
application.register("ruby-ui--combobox-content", RubyUi__ComboboxContentController)

import RubyUi__ComboboxController from "./ruby_ui/combobox_controller"
application.register("ruby-ui--combobox", RubyUi__ComboboxController)

import RubyUi__ComboboxItemController from "./ruby_ui/combobox_item_controller"
application.register("ruby-ui--combobox-item", RubyUi__ComboboxItemController)

import RubyUi__DialogController from "./ruby_ui/dialog_controller"
application.register("ruby-ui--dialog", RubyUi__DialogController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)

import RubyUi__SheetContentController from "./ruby_ui/sheet_content_controller"
application.register("ruby-ui--sheet-content", RubyUi__SheetContentController)

import RubyUi__SheetController from "./ruby_ui/sheet_controller"
application.register("ruby-ui--sheet", RubyUi__SheetController)

import RubyUi__TabsController from "./ruby_ui/tabs_controller"
application.register("ruby-ui--tabs", RubyUi__TabsController)

import RubyUi__TooltipController from "./ruby_ui/tooltip_controller"
application.register("ruby-ui--tooltip", RubyUi__TooltipController)

import SeatsController from "./seats_controller"
application.register("seats", SeatsController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SmallchatController from "./smallchat_controller"
application.register("smallchat", SmallchatController)
